export default __webpack_public_path__ + "static/intermision_two-da565ab6ca2ccb248b77fa0af33d0c7a.jpg";